export const DATA_KEYS_PERDIDAS_GANANCIAS = {
  "-1": {
    className: "tw-font-medium tw-text-md tw-text-left tw-pl-8",
    rowClassName: "tw-border-t-2 tw-border-neutral-25 [&>td]:tw-font-medium",
    rowNumberClassName: "tw-text-md tw-font-medium tw-px-3 tw-py-3",
  },
  1: {
    className:
      "tw-text-left tw-w-full tw-font-medium tw-text-lg tw-border-neutral-25 tw-border-b-2",
    rowClassName: "tw-border-b-2 tw-border-neutral-25 [&>td]:tw-font-medium",
    tipoInformeSumaSaldo: 5,
    rowNumberClassName: "tw-text-lg tw-font-medium tw-px-3 tw-py-3",
  },
  2: {
    className: "tw-text-left tw-font-medium tw-text-sm tw-pl-8",
    rowClassName:
      "tw-border-b tw-border-neutral-25 tw-border-dashed [&>td]:tw-font-medium",
    tipoInformeSumaSaldo: 4,
    rowNumberClassName: "tw-text-sm tw-font-normal tw-px-3 tw-py-3",
  },
  3: {
    className: "tw-text-left tw-font-medium tw-text-sm tw-pl-10",
    tipoInformeSumaSaldo: 3,
    rowNumberClassName: "tw-text-sm tw-font-medium tw-px-3 tw-py-3",
  },
  4: {
    className: "tw-text-left tw-font-medium tw-text-sm tw-pl-4",
    tipoInformeSumaSaldo: 2,
    rowNumberClassName: "tw-text-sm tw-font-medium tw-px-3 tw-py-3",
  },
  5: {
    className:
      "tw-text-left tw-text-sm tw-pl-14 tw-font-normal [&>div]:tw-gap-2 [&>div]:tw-flex [&>div]:tw-items-center [&>div>.status-icon]:tw-px-1 [&>div>span:nth-child(2)]:tw-inline-block  [&>div>span:nth-child(2)]:tw-whitespace-normal [&>div>span]:tw-break-words",
    tipoInformeSumaSaldo: 1,
    rowNumberClassName: "tw-text-sm tw-font-normal tw-px-3 tw-py-3",
  },
}

export const TIPO_INFORMES_PERDIDA_GANANCIA = (t: $TSMigrationFixMe) => [
  { value: 0, label: `${t("informes.perdidasGanancias.header.resultLabel")}` },
  { value: 2, label: `${t("informes.perdidasGanancias.header.groupLabel")}` },
  {
    value: 3,
    label: `${t("informes.perdidasGanancias.header.subGroupLabel")}`,
  },
  { value: 4, label: `${t("informes.perdidasGanancias.header.accountLabel")}` },
]
